// ag-grid-enterprise v21.2.2
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function chainObjects(parent, child) {
  var obj = Object.create(parent);

  for (var prop in child) {
    if (child.hasOwnProperty(prop)) {
      obj[prop] = child[prop];
    }
  }

  return obj;
}

exports.chainObjects = chainObjects;